import { render, staticRenderFns } from "./RecruitmentRequestPage.vue?vue&type=template&id=1f13205b&"
import script from "./RecruitmentRequestPage.vue?vue&type=script&lang=js&"
export * from "./RecruitmentRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports